import { Link, useNavigate } from 'react-router-dom'
import { usePutResetPasswordMutation } from '../../api/api'
import * as Yup from 'yup'
import { useEffect } from 'react'
import { Formik } from 'formik'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import useQuery from '../../utils/hooks/useQuery'
import PasswordInput from '../../components/PasswordInput/PasswordInput'

const ResetPasswordView = ({ user }) => {
  const navigate = useNavigate()
  const queryParams = useQuery()
  const [putResetPassword, { isLoading, error }] = usePutResetPasswordMutation()
  const resetId = queryParams.id
  const errors = error?.data?.errors || []
  const schema = Yup.object().shape({
    password: Yup.string()
      .required('Password is a required field')
      .min(8, 'Password must be at least 8 characters'),
  })

  useEffect(() => {
    if (user?.id) {
      navigate('/library')
    }
  }, [navigate, user?.id])

  function handleSubmit(values) {
    putResetPassword({ id: resetId, password: values.password })
  }

  return (
    <div className="flex w-full h-full items-center justify-center">
      <div className="bg-gray-light w-[400px] p-6 rounded drop-shadow-lg mb-10 relative">
        <h1 className="text-center mb-6">Reset Password</h1>
        <p className="mt-4 mb-2">
          Enter your new password below. Passwords must contain at least 8
          characters.
        </p>

        {errors?.length > 0 && (
          <div className="p-4 bg-pink-dark rounded border border-pink-error mt-4">
            {errors.map(({ error }, i) => (
              <p key={i}>{error}</p>
            ))}
          </div>
        )}
        <Formik
          validationSchema={schema}
          initialValues={{ email: '', password: '' }}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <div className="login">
              <div className="form">
                <form noValidate onSubmit={handleSubmit}>
                  <label className="mt-4 inline-block" htmlFor="Password">
                    Password
                  </label>
                  <PasswordInput
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    placeholder="Enter password"
                    className="form-control"
                  />
                  <p className="error">
                    {errors.password && touched.password && errors.password}
                  </p>
                  <div className="flex justify-end pt-6">
                    <div>
                      <Link
                        className="button bg-transparent text-white-dark inline-block"
                        to="/login"
                      >
                        Back
                      </Link>
                    </div>
                    <div>
                      <button
                        className="button bg-pink hover:bg-pink-off"
                        type="submit"
                      >
                        Reset Password
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </Formik>
        {isLoading && <LoadingBlocker />}
      </div>
    </div>
  )
}
export default ResetPasswordView
